import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { useGlobal } from 'reactn';
import Cookies from 'js-cookie'


const { Sider } = Layout;

const SideMenu = ({ testFunc }) => {
  let [, setToken] = useGlobal("token");

  const [collapsed, setCollapsed] = useGlobal('collapsed');

  function tabTitle(titleName) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.title = "FutureLive" + " - " + titleName;
  }

  let logout = (props) => {
    Cookies.remove('token')
    localStorage.removeItem('modules')
    setToken(null)
  }

  return (
    <Sider collapsible collapsed={collapsed} onCollapse={() => setCollapsed(!collapsed)} theme="light" width="260">
      <div className="logo-wrap">
        <div className="logo"></div>
      </div>
      <Menu theme="light" defaultSelectedKeys={['1']} mode="inline">
        <Menu.Item key="questionSet" onClick={() => tabTitle("Soru Setleri")}>
          <Link to={"/questionSet"}>
            <img alt="" src={"/images/Question.png"} width="40" />
            <span>{"Soru Setleri"}</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="streams" onClick={() => tabTitle("Yayınlar")}>
          <Link to={"/streams"}>
            <img alt="" src={"/images/youtube.png"} width="40" />
            <span>{"Yayınlar"}</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="results" onClick={() => tabTitle("Sonuçlar")}>
          <Link to={"/results"}>
            <img alt="" src={"/images/Trello.png"} width="40" />
            <span>{"Sonuçlar"}</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="users" onClick={() => tabTitle("Kullanıcılar")}>
          <Link to={"/users"}>
            <img alt="" src={"/images/user.png"} width="40" />
            <span>{"Kullanıcılar"}</span>
          </Link>
        </Menu.Item>
        {/* <Menu.Item key="notifications" onClick={() => tabTitle("Bildirimler")}>
          <Link to={"/notifications"}>
            <img alt="" src={"/images/Notification.png"} width="40" />
            <span>{"Bildirimler"}</span>
          </Link>
        </Menu.Item> */}
        <Menu.Item key="adminInfo" onClick={() => tabTitle("Admin Bilgileri")}>
          <Link to={"/adminInfo"}>
            <img alt="" src={"/images/Admin.png"} width="40" />
            <span>{"Admin Bilgileri"}</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="logout" onClick={logout}>
          <Link to={"/logout"}>
            <img alt="" src={"/images/Logout.png"} width="40" />
            <span>{"Çıkış"}</span>
          </Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
};


export default SideMenu;
